<template>
    <div class="ml-404">
        Hello CSP Test
    </div>
</template>
  <script type="text/babel">
export default {
  title: "找不着页面了",
};
</script>
  <style lang="scss" scoped>
  .ml-404 {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 200px;
    left: 0;
    min-height: 520px;
    overflow: hidden;
    background-color: #f5f5f5;
  }

</style>
  